import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import type { HeaderProps, NavItem } from '../../types';
import { scrollToId } from '../../hooks/useScrollTo';

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems: NavItem[] = [
    { label: 'Expertise', href: 'expertise' },
    { label: 'Solutions', href: 'solutions' },
    { label: 'Approach', href: 'approach' },
    { label: 'Contact', href: 'contact' },
  ];

  return (
    <header className={`relative flex justify-between items-center mb-20 ${className}`}>
      <div className="flex items-center space-x-1">
        <img
          src="/logo-light.png"
          alt="Theocraft"
          className="h-16 w-auto"
        />
      </div>
      <nav className="hidden md:flex space-x-8">
        {navItems.map((item) => (
          <button
            key={item.href}
            onClick={() => scrollToId(item.href)}
            className="text-body hover:text-white transition-colors cursor-pointer focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:outline-none rounded-md px-2 py-1"
          >
            {item.label}
          </button>
        ))}
      </nav>
      <button
        className="md:hidden p-2 text-white focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:outline-none rounded-md"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isMobileMenuOpen}
      >
        {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-sm border-t border-gray-800 z-50 rounded-b-xl">
          <nav className="flex flex-col p-4 space-y-4">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => { scrollToId(item.href); setIsMobileMenuOpen(false); }}
                className="text-body text-gray-300 hover:text-white transition-colors text-left focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:outline-none rounded-md px-2 py-1"
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
